import React from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Upload from '@mui/icons-material/Upload';
import { styled } from '@mui/material/styles';
import { AllPolicyXML } from '../../xmlParsing/interfaces';
import { parseXMLPolicy } from '../../xmlParsing/parseXML';
import { ErrorXMLParsing } from '../../utils/ErrorReturn';
import { setComponentsOnUpload } from '../../store';
import { useDispatch } from 'react-redux';
import { UploadPolicyBtProps } from '../../view-models';

function UploadPolicyButton({ type = 'InitUpload' }: UploadPolicyBtProps) {
  const dispatch = useDispatch();
  const Input = styled('input')({
    display: 'none',
  });

  const handleMultipleFileInput = (target: EventTarget & HTMLInputElement) => {
    const filesCount = target.files?.length || 0;
    let filesList: Array<File> = [];
    for (let i = 0; i < filesCount; i++) {
      let newFile = target.files?.item(i);
      if (newFile !== undefined && newFile !== null) filesList.push(newFile);
    }

    let fileStrings: Array<{ name: string; fileString: string }> = [];
    let readers: Array<Promise<string>> = [];

    filesList.forEach((file: File) => readers.push(file.text()));

    Promise.all(readers).then((values) => {
      values.forEach((val, index) => fileStrings.push({ name: filesList[index].name, fileString: val }));

      let newInfo: AllPolicyXML | ErrorXMLParsing = parseXMLPolicy(fileStrings);
      console.log(newInfo);
      if (newInfo.hasOwnProperty('error') || newInfo.hasOwnProperty('xmlTrace')) {
        window.alert(newInfo);
      } else if (
        // @ts-ignore
        Object.keys(newInfo['rpComponents'] || {}).length === 0 ||
        // @ts-ignore
        Object.keys(newInfo['rpInheritance'] || {}).length === 0
      ) {
        window.alert('Please upload the RP Files and dependent files.');
      } else {
        dispatch(setComponentsOnUpload(newInfo));
      }
    });
  };

  const handleXMLFileInput = (target: EventTarget & HTMLInputElement) => {
    target.files !== null && target.files.length !== 0 && handleMultipleFileInput(target);
    target.value = '';
  };

  return (
    <label htmlFor="policyUpload">
      <Input
        type="file"
        multiple={true}
        name="policyUpload"
        id="policyUpload"
        accept=".xml"
        onChange={(e: { target: EventTarget & HTMLInputElement }) => handleXMLFileInput(e.target)}
      />
      {type === 'InitUpload' ? (
        <>
          <Button component="span">Upload Policy</Button>
        </>
      ) : (
        <>
          <IconButton component="span" color="primary" aria-label="upload policy">
            <Upload />
          </IconButton>
        </>
      )}
    </label>
  );
}

// export default withAITracking(reactPlugin, UploadPolicyButton);
export default UploadPolicyButton;
